export default __webpack_public_path__ + "static/char-thumb-18-e283153086870eae60caa38e695b7ca8.png";